import { Component, OnInit, OnDestroy } from '@angular/core';
import { ErrorService } from '../services/error.service';
import { LoggingMessageService } from '../services/logging-message.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit, OnDestroy {

  constructor(private authService: AuthService, private logger: LoggingMessageService, public errorService: ErrorService) { }

  ngOnInit() {
    this.logger.info('page-not-found.component', 'ngOnInit',  this.authService.SelectedSubscription , this.authService.AvailableSubscriptionsString, 'Indicator Factory page not found.', '');
  }

  ngOnDestroy() {
    this.errorService.errorMessage = '';
  }

}
